import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

/**
 * @param {{
 *   query?: {
 *     search?: string,
 *     productCategoryId?: string,
 *     page?: number,
 *     limit?: number,
 *     isActive?: boolean
 *   }
 * }} [option]
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.ProductBrand.GetAll(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ name: string }} form
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.ProductBrand.Create(), form);
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { id: string }, query?: object }} option
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.ProductBrand.GetById(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{
 *   params: { id: string },
 *   body: { name?: string, isActive?: boolean }
 * }} option
 */
export const Update = async (option) => {
  const response = await $api.put(
    Endpoints.ProductBrand.Update({ params: option.params }),
    option.body
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { id: string } }} option
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.ProductBrand.Delete(option));
  return ResponseChecker(defaultMessages, response);
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
